<template>
  <transition name="fade">

    <div class="team-page">
      <div class="section-container" id="team-fullpage">
        <section class="landing-screen market-screen team-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
              <div class="headline-3"><b>企业愿景</b></div>
                <div class="headline-1">
                   <b>国际领先的<br/>产业投资孵化平台</b>
                </div>
                <div class="description">
                 我们始终坚持以“升级中国产业”为目标，通过将更多前沿的全球领先工业级技术的商业化落地，积极推动具有中国战略价值的产业新生态的诞生。
                </div>
              </div>
            </div>
           <div class="col">
                <div class="bg-wish"></div>
            </div>
            </div>
        </section>
        <section class="landing-screen market-screen team-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-cultrue">
           <div class="text-cultrue">
             <div class="headline-3"><b>核心价值观</b></div>
             <div class="headline-1"><b>务实</b>/<b>严谨</b>/<b>创造</b>/<b>有韧性</b></div>
             <div class="description">
                 我们将绿展的核心价值观定义为“绿展范”——务实、严谨、用心、创造、有韧性。绿展范是绿展企业文化的重要组成部分，是我们共同认可的行为准则。
             </div>
           </div>
            <div class="circle-cultrue">
            <div class="circle">
            <img src="../assets/cultrue/wushi.png">
             <div class="circle-2">
            <div class="headline-4">务实</div>
            <div class="headline-5">想大事，做小事。<br/>一切只强调实际贡献。</div>
            </div>
            </div>
            <div class="circle">
             <img src="../assets/cultrue/yanjin.png">
             <div class="circle-2">
            <div class="headline-4">严谨</div>
            <div class="headline-5">垂直深度思考。<br/>有方向，有方法，有方案。<br/>一切争论用数据说话。</div>
            </div>
            </div>
            <div class="circle">
              <img src="../assets/cultrue/yongxin.png" alt="" />
              <div class="circle-2">
                <div class="headline-4">用心</div>
                <div class="headline-5">对工作用心，<br />对客户用心。</div>
              </div>
            </div>
            <div class="circle">
             <img src="../assets/cultrue/chuangzao.png">
             <div class="circle-2">
            <div class="headline-4">创造</div>
            <div class="headline-5">勇于突破,持续进化。</div>
            </div>
            </div>
            <div class="circle">
             <img src="../assets/cultrue/yourenxing.png">
                 <div class="circle-2">
            <div class="headline-4">有韧性</div>
            <div class="headline-5"> 开源节流，精打细算。<br/>吃苦耐劳，保持正能量。</div>
            </div>
            </div>
         </div>
          </div>
        </section>
        <section class="landing-screen market-screen team-slider section" id="landingScreen" v-view="hidePitfall">
                <div class="headline-11">
                   <b>我们的团队：科技团队</b>
                </div>
          <div class="grid-container">
            <div class="grid-item"> <img src="../assets/team/ceo.png"></div>
            <div class="grid-item"><img src="../assets/team/cto1.png"></div>
            <div class="grid-item"><img src="../assets/team/cto2.png"></div>
            <div class="grid-item"><img src="../assets/team/svp.png"></div>
            <div class="grid-item"><img src="../assets/team/coo.png"></div>
            <div class="grid-item"><img src="../assets/team/cmo.png"></div>
          </div>
        </section>
        <section class="landing-screen market-screen team-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1">
                   <b>我们的团队：文化团队</b>
                </div>
                <div class="description">
                 <br> ●开国上将邓华之子、中国战略与管理研究会志愿军研究会会长邓穗；
                 <br> ●中国动漫发源地上海美术电影制片厂原技术委员会主任、总工程师、中国水墨动画发明人段孝萱；
                 <br> ●中国微动漫创始人、社团法人日中教育文化振兴会常务理事虞为；
                 <br> ●成功将美国杜克大学落户昆山的美国大学联盟ACL中国中心总干事江冰；
                 <br> ●美国大学联盟（ACL）中国中心科创项目负责人李公；
                 <br> ●社团法人日中教育文化振兴会理事长王智新；
                 <br> ●与吴宇森合作过电影《赤壁》上下集的知名制片人王大维；法国著名青年动漫艺术家托马斯罗曼；日本著名青年动漫艺术家津田尚克；
                 <br> ●国际动漫大师、变形金刚之父河森正治；
                 <br> ●以及国际数字动漫开创者、多次获得国际科幻影视最高奖星云奖的名门SATELIGHT等企业组成。
                </div>
              </div>
            </div>
           <div class="col">
                <div class="bg-team"></div>
            </div>
            </div>
        </section>
         <section class="landing-screen market-screen team-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-cultrue">
           <div class="text-cultrue">
             <div class="headline-1"><b>我们的法律顾问</b></div>
             <div class="col-25">
             <img src="../assets/B-BLogo.png">
              </div>
             <div class="description">
                  Baker Botts是一家国际律师事务所，在全球设有14个办事处，拥有725位执业律师开展业务。基于他们对客户行业的经验和知识，Baker Botts被公认为能源和技术领域的领先公司，专注于知识产权保护。
             </div>
             <div class="col-25">
             <img src="../assets/FHlogo.png">
              </div>
             <div class="description">
                  Foley Hoag是一家富有创新思维的律师事务所，致力于为全球范围内的私人及企业解决各类交易纠纷。
                  <br>FoleyHoag专注于生命科学、医疗保健、科学技术、能源&可再生能源、投资管理、专业服务和教育等行业。
                  <br>Foley Hoag在波士顿、纽约、巴黎和华盛顿特区等城市设有办事处，为世界范围内的客户提供量身定制的战略法律咨询。
             </div>
         </div>
          </div>
        </section>
        <section class="landing-screen market-screen team-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1"><b>加入我们</b></div>
                <div class="description">
                   我们一直在寻找具有创业精神的高学历人才。如果您符合我们的要求，并且您也正在寻找一家高速发展、愿意与员工共建未来的全球性公司，请联系我们！
                </div>
              </div>
          </div>
          <div class="col">
            <div class="join-us-container  lightgreen-gradient-bg">
              <div class="line-1">如果您</div>
              <div class="line-2">有兴趣加入我们</div>
              <div class="line-2">请点击下方的按钮与我们联系</div>
                <div class="line-3">我们会第一时间给您回复</div>
             <div><a href="mailto:hr@greenprosperitygroup.com" ><img src="../assets/mail.png"></a></div>
            </div>
          </div>
          </div>
        </section>
        <GPFooter />
      </div>
   </div>
  </transition>
</template>

<style lang="scss" src="./TeamPage.scss">
</style>

<script>
import Fullpage from 'fullpage.js'
export default {
  name: 'TeamPage',
  props: {},
  data () {
    return {
      teamSliders: null,
      isPitfallHide: true
    }
  },
  methods: {
    formatter (num) {
      return num.toFixed(1)
    },
    animStart (e, n) {
      this.$refs[`teamNum_${n}`].start()
    },
    hidePitfall () {
      this.isPitfallHide = true
    },
    showPitfall () {
      this.isPitfallHide = false
    },
    resizeEvent (e) {
      e.stopPropagation()
      if (document.body.offsetWidth > 1024 && this.teamSliders === null) {
        this.initFullPage()
      }
    },
    initFullPage () {
      this.teamSliders = new Fullpage('#team-fullpage', {
        licenseKey: 'FAE6D29E-C9664B70-A1915489-3CEF9EF7',
        autoScrolling: true,
        lazyLoading: true,
        easingcss3: 'cubic-bezier(0.75, 0, 0.25, 1)',
        fitToSectionDelay: 180,
        fadingEffect: false,
        animateAnchor: false,
        scrollingSpeed: 800,
        scrollBar: true,
        navigation: true,
        navigationPosition: 'left',
        afterResize: (width, height) => {
          if (width < 1024) {
            this.teamSliders.destroy('all')
            this.teamSliders = null
          }
        }
      })
    }
  },
  created () {
  },
  destroyed () {
    if (this.teamSliders !== null) {
      this.teamSliders.destroy('all')
      this.teamSliders = null
    }
    window.removeEventListener('resize', this.resizeEvent)
  },
  mounted () {
    window.addEventListener('resize', this.resizeEvent)
    if (document.body.offsetWidth > 1024 && this.teamSliders === null) {
      this.initFullPage()
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/TeamPage.vue